export default "__VITE_ASSET__BqzD2xMx__"